<!-- Contact Start -->
<div class="container-xxl py-5" id="contact">
    <div class="container py-5 px-lg-5">
        <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h5 class="text-primary-gradient fw-medium">Contact Us</h5>
            <h1 class="mb-5">Get In Touch!</h1>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="wow fadeInUp" data-wow-delay="0.3s">
                    <form class="form" #Form="ngForm" (ngSubmit)="onSubmit(Form)">
                        <input type="hidden" name="key" value="0D789A874A">
                        <input type="hidden" name="value" value="EF01C0D7D2">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input name="name" [(ngModel)]="formData.name" required type="text"
                                        class="form-control" placeholder="Name">
                                    <label for="name">Your Name</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input name="email" [(ngModel)]="formData.email" required type="email"
                                        class="form-control" placeholder="Email">
                                    <label for="email">Your Email</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-floating">
                                    <input name="phone" [(ngModel)]="formData.subject" required type="text"
                                        class="form-control" placeholder="Phone">
                                    <label for="subject">Subject</label>
                                </div>
                            </div>


                            <div class="col-12">
                                <div class="form-floating">
                                    <textarea name="message" [(ngModel)]="formData.message" required
                                        class="form-control" style="height: 150px"
                                        placeholder="Leave a message here"></textarea>
                                    <label for="message">Message</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="recaptcha-wrapper">
                                    <re-captcha siteKey="6LecstspAAAAAJBhT3n2hfQragrEwgJuoD3t0RRk"
                                        (resolved)="onCaptchaResolved($event)" name="recaptcha" required
                                        ngModel></re-captcha>
                                </div>
                            </div>
                            <div class="col-12 text-center">
                                <button class="btn btn-primary-gradient rounded-pill py-3 px-5" type="submit"
                                    [disabled]="isLoading">
                                    {{ isLoading ? 'Sending...' : 'Send Message' }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Contact End -->